import React, { useState, useEffect } from 'react';
import selectGender_icon from '../../../../images/icons/UserKycIcons/selectGender_icon.svg';
import styles from './Loan.module.css';

function MbCommonModalPropertyType({
  sendUrl,
  sendloanType,
  selectPropertyType,
  typeOfProperty,
  setShow
}) {
  const { icon_style_modal_bottom, mbSelectOption } = styles;

  return (
    <div
      className={`${
        sendloanType === typeOfProperty ? mbSelectOption : 'p-2'
      } p-2 relative`}
    >
      <img
        src={selectGender_icon}
        className={`${
          sendloanType === typeOfProperty ? icon_style_modal_bottom : 'hidden'
        }`}
      />
      <div
        onClick={() => {
          selectPropertyType();
          setShow(false);
        }}
        className="flex items-center"
      >
        <div className="h-10 w-10 mr-6">
          <img src={sendUrl} alt="" className="w-full h-full" />
        </div>
        <div className="text-black-600 font-roboto font-normal">
          <div className="text-base font-roboto text-grey-920">
            {sendloanType}
          </div>
        </div>
      </div>
    </div>
  );
}
export default MbCommonModalPropertyType;
